export default __webpack_public_path__ + "static/media/team8.5aadf080.JPG";